import Api from "./Api";

export default {
    getSeatLayout(payload) {
        return Api().get(`/api/vista/seat-layout/${payload.vista_schedule_id}`);
    },
    reserveSeats(payload) {
        return Api().post(`/api/external/vista/reserve-seats`, payload);
    },
}


// WEBPACK FOOTER //
// ./src/services/vistaServices.js